import React, { FunctionComponent } from 'react';

import { SectionVideo } from '@gojob/cms';
import Text from '@gojob/ui-bits/Text';
import { graphql } from 'gatsby';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import EmbeddedVideo from '../../Article/EmbeddedVideo';
import BreakpointContainer from '../../BreakpointContainer';
import Buttons from '../../Buttons';

export const SectionVideoFragment = graphql`
  fragment SectionVideoFragment on SanitySectionVideo {
    title {
      title
      level
    }
    video {
      src
      aspectRatio
    }
    cta {
      ...CtaFragment
    }
    _type
  }
`;

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();

  return {
    buttons: {
      boxSizing: 'border-box',
      padding: spacing(2, 4, 2),
      [breakpoint.up('md')]: {
        padding: spacing(4, 0, 4),
      },
    },
  } as const;
};

const Video: FunctionComponent<SectionVideo> = (props) => {
  const { title, video, cta } = props;

  const classes = useStyles();

  return (
    <BreakpointContainer
      css={{ overflow: 'hidden' }}
      alignItems="center"
      maxWidth="xl"
      padding={{ xs: [8, 0, 0], md: [8, 0, 0] }}
    >
      <Text variant="headline2" as={title?.level} css={{ textAlign: 'center' }}>
        {title?.title}
      </Text>

      <EmbeddedVideo width="100%" margin={[4, 0, 0]} src={video?.src} aspectRatio={video?.aspectRatio} />

      {cta?.children ? <Buttons css={classes.buttons} ctas={[cta]} /> : null}
    </BreakpointContainer>
  );
};

export default Video;
